import React, { Component } from 'react';
import { Formik, Form } from 'formik';

import queryString from "query-string";


import DatePickerField from "../forms/DatePickerField";

import AccountTimesheetDisplay from "./widgets/AccountTimesheetData"

import { observer } from 'mobx-react';

import LoadingOverlay from 'react-loading-overlay';


class CertifyTimesheets extends Component {
    static displayName = CertifyTimesheets.name;

    constructor(props) {
        super(props);

        let params = queryString.parse(props.location.search)

        this.state = {
            loading: true,
            startDate: this.getStartDate(), 
            endDate: this.getNextFriday(new Date()),

            certifyKey: "timesheet_" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER),

            submissionFilter: params.submissionFilter ? params.submissionFilter : "Uncertified"
        };

        this.props.store.updateBanner("Certify Timesheets", false, true);

        this.updateSubmissionFilter = this.updateSubmissionFilter.bind(this);

        this.updateStartDate = this.updateStartDate.bind(this);
        this.updateEndDate = this.updateEndDate.bind(this);

        this.filterAccountsByDate = this.filterAccountsByDate.bind(this);

        this.displayCertifyButton = this.displayCertifyButton.bind(this);
        this.toggleCertify = this.toggleCertify.bind(this);
        this.certifyAll = this.certifyAll.bind(this);
    }

    updateStartDate(date) {
        this.setState({ startDate: date });

        let windowStorage = window.localStorage;
        windowStorage.setItem("SWS_chronosStartDate", date);
    }

    updateEndDate(date) {
        console.log(date)
        this.setState({ endDate: date })
    }

    updateSubmissionFilter(event) {
        this.setState({
            submissionFilter : event.target.value,
        });
    }


    getStartDate() {
        let windowStorage = window.localStorage;
        let startDate = windowStorage.getItem("SWS_chronosStartDate")

        if (startDate != null && startDate != "null") {
            return new Date(startDate);
        }
        else {
            var resultDate = new Date();
    
            resultDate.setMonth(resultDate.getMonth() - 3);
        
            return resultDate;    
        }
    }

    getNextFriday(date) {    
        var resultDate = new Date();
    
        resultDate.setDate(date.getDate() + (7 + 5 - date.getDay()) % 7);
    
        return resultDate;
    }


    displayFilters() {

        return (
            <React.Fragment>
            <div className="row">
                <div className="col-12 col-md-6 d-flex flex-column">
                        <h3 className="h5 mb-2 d-block">Include in search:</h3>
                        
                        <select className="form-control" 
                            name="submissionFilter" 
                            value={this.state.submissionFilter} 
                            onChange={this.updateSubmissionFilter}
                        >
                            <option value="All">All</option>
                            <option value="Uncertified">Uncertified</option>
                            <option value="Certified">Certified</option>
                        </select>
                </div>
                <div className="col-12 col-md-6">
                    <h3 className="h5 d-block">Filter by <span style={{color: "#A41E35"}}>Submission Date:</span></h3>

                    <Formik
                        onSubmit={(values) => true }
                        initialValues={{ startDate: this.state.startDate, endDate: this.state.endDate }}
                        validate={values => {}}
                    >
                        <Form>

                            <DatePickerField 
                                name="startDate" 
                                onChange={this.updateStartDate} 
                                label="Start Date" 
                            />
                            
                            <DatePickerField name="endDate" 
                                onChange={this.updateEndDate} 
                                label="End Date"
                            />
                        </Form>
                    </Formik>
                </div>
            </div>
            <div className="row mt-3">
                <div className="ml-auto">
                    <button className="btn btn-primary" onClick={() => window.print()}>Print This Page</button>
                    <button className="btn btn-secondary ml-2" onClick={this.certifyAll}>Certify All</button>
                </div>
            </div>
            </React.Fragment>
        );
    }



    render() {
        return (
            <div>
                <div className="container">
                    {this.displayFilters()}
                </div>
                {this.displayTimesheets()}
            </div>
        )
    }


    filterAccountsByDate(accounts) {

        const filtered_accounts = accounts.map(account => {
            account = account.include(["student", "timestamp", "timesheet"]);

            let timesheets = account.timesheets;

            if (timesheets && timesheets.length > 0) {
                timesheets = timesheets.filter((timesheet) => {

                        //Make sure timesheet EXISTS
                        if (timesheet != null) {
                            //Ensure it is submitted - we don't show unsubmitted timesheets to admins
                            if (timesheet.isFinal == false ) {
                                return false;
                            }

                            //If we have a cert or uncertified filter disabled
                            if (this.state.submissionFilter === "Certified") {
                                if(!timesheet.isCertified) {
                                    return false;
                                }
                            }
                            //If we have a cert or uncertified filter disabled
                            if (this.state.submissionFilter === "Uncertified") {
                                if(timesheet.isCertified) {
                                    return false;
                                }
                            }

                            //console.log(new Date(this.state.startDate))
                            let passesStartDate = true;
                            if (this.state.startDate) {
                                passesStartDate = new Date(timesheet.dateSubmitted) >= new Date(this.state.startDate)
                            }

                            let passesEndDate = true;
                            if (this.state.endDate){
                                passesEndDate = new Date(timesheet.dateSubmitted) <= new Date(this.state.endDate)
                            };


                            return (passesStartDate && passesEndDate);
                        }
                    });
                account.timesheets = timesheets;
            }
            else {
                account.timesheets = []
            }
            return account;
        });

        return filtered_accounts;
    }

    async certifyAll() {
        if(window.confirm("Are you sure you would like to certify all timesheets on the page?")) {
            let timesheetIdsToUpdate = [];

            let accounts = this.props.store.accounts.collection;

            accounts = this.filterAccountsByDate(accounts);


            for(let i = 0; i < accounts.length; i++) {
                let account = accounts[i];

                if (account.timesheets.length > 0) {
                    account.timesheets.map(timesheet => timesheetIdsToUpdate.push(timesheet.id))
                }
            }

            timesheetIdsToUpdate.forEach(timesheetId => {
                let timesheet = this.props.store.timesheets.getById(timesheetId);
                
                if (!timesheet.isCertified) {
                    timesheet.isCertified = true;
                    timesheet.save(this.props.store)
                }
            });

            //await this.props.store.getFromApi();
            const key = "timesheet_" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);

            this.setState({certifyKey : key})

            this.props.store.getFromApi();

        }
    }


    async toggleCertify(event) {
        this.props.store.setLoading(true);

        let timesheetId = event.target.value;
        let timesheet = this.props.store.timesheets.getById(timesheetId);

        //mutate timesheet
        timesheet.isCertified = !timesheet.isCertified;

        //save to api
        let response = await timesheet.save(this.props.store);

        console.log(response)
        if (response && response.errors) {
            timesheet.isCertified = !timesheet.isCertified;
        }

        const key = "timesheet_" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);

        this.setState({certifyKey : key});

        this.props.store.setLoading(false);
    }

    displayCertifyButton(timesheetId) {

        let timesheet = this.props.store.timesheets.getById(timesheetId)
        
        if (!timesheet.isCertified) {
            return (
                <button key={this.state.certifyKey + "_" + timesheet.id} className="btn btn-light" value={timesheetId.toString()} type="button" onClick={this.toggleCertify}>
                    Certify
                </button>
            )
        }
        return (
            <button key={this.state.certifyKey + "_" + timesheet.id} className="btn btn-secondary" value={timesheetId.toString()} type="button" onClick={this.toggleCertify}>
                Uncertify
            </button>
        )
    }


    
    displayTimesheets() {

        let accounts = this.props.store.accounts.collection;

        accounts = this.filterAccountsByDate(accounts)

        accounts = accounts.filter(account => account.timesheets.length > 0)


        let tableOptions = {
            showEdit : true,
            showLoggedToggle : false,
            showCertify : true,
            showStudentName : true,
            showEmployerName : true,
            showFopal : false,
            showTotalHours : true,
            showSubmittedDate: true,
            showCertifiedDate : true,
            showWeekEndDate : true,
            showTimestampRange : true,
            showWeekPay : true,
            showBalance : true,
        }

        if (accounts.length > 0) {
            return (
                <AccountTimesheetDisplay
                    options={tableOptions}
                    accountIds={accounts.map(account => account.id)}
                    store={this.props.store}

                    tableProps={{ style: "mt-4" }}
                    headerGroupProps={{}}
                    rowProps={{}}

                    displayCertify={this.displayCertifyButton}

                    key={this.state.certifyKey}

                />
            );
        }
        else {
            return(
                <div>
                    <h2 className="h4 mt-4">Could not find any timesheets matching the filter parameters.</h2>
                </div>
            )
        }
    }
}

CertifyTimesheets = observer(CertifyTimesheets)

export {CertifyTimesheets};